import React from 'react';

const HowHelp = () => {

    return (
        <div>
        </div>
    );
};

export default HowHelp;
